import { useEffect } from "react";

export function useFacebookPixel() {
  useEffect(() => {
    const PIXEL_ID = process.env.REACT_APP_FACEBOOK_PIXEL_ID;
    if (!PIXEL_ID) return;

    // Check if script already exists
    if (document.getElementById("fb-pixel-script")) return;

    // Create fbq script
    const script = document.createElement("script");
    script.id = "fb-pixel-script";
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);

    // Initialize fbq
    window.fbq =
      window.fbq ||
      function (...args) {
        if (window.fbq.callMethod) {
          window.fbq.callMethod(...args);
        } else {
          window.fbq.queue.push(args);
        }
      };

    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = "2.0";
    window.fbq.queue = [];

    // Initialize Pixel
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");

    // Optional: log success
    console.log("✅ Facebook Pixel initialized:", PIXEL_ID);
  }, []);
}
